import { render, staticRenderFns } from "./LabScientistDashboard.vue?vue&type=template&id=1f6f41d7&scoped=true&"
import script from "./LabScientistDashboard.vue?vue&type=script&lang=js&"
export * from "./LabScientistDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f6f41d7",
  null
  
)

export default component.exports